import {generateId} from '../app/utils';

export function advanceSearchCriteria (array) {
	return {
		type: "ADVANCE_SEARCH_CRITERIA",
		payload: array
	}
}

export function addCriteria () {
	return function (dispatch, getState) {
		if(getState().advanceSearchReducer.advanceSearchCriteria.length > 0){
			dispatch(
				advanceSearchCriteria([
					...getState().advanceSearchReducer.advanceSearchCriteria,
					{
						id: generateId(),
						field: '',
						operator: '',
						value: ''
					}
				])
			)
		} else {
			dispatch(
				advanceSearchCriteria([
					{
						id: generateId(),
						field: '',
						operator: '',
						value: ''
					}
				])
			)
		}
	}
}

export function removeCriteria (index) {
	return function (dispatch, getState) {
		dispatch(
			advanceSearchCriteria(getState().advanceSearchReducer.advanceSearchCriteria.slice(0, parseInt(index, 10)).concat(getState().advanceSearchReducer.advanceSearchCriteria.slice(parseInt(index, 10) + 1)))
		)
	}
}

export function updateCriteria(index, updatedFields) {
	return function (dispatch, getState) {
		const current = getState().advanceSearchReducer.advanceSearchCriteria;
		const updated = current.map((crit, i) =>
			i === index ? { ...crit, ...updatedFields } : crit
		);
		dispatch(advanceSearchCriteria(updated));
	};
}

export function criterionError (string) {
	return {
		type: "CRITERION_ERROR",
		payload: string
	}
}